export enum EditionMarketingFieldDisplayType {
  Boolean = 1,
  Text,
  KeySellingPoint,
}

export class ChangedField {
  fieldName: string;
  displayType: EditionMarketingFieldDisplayType;
  oldValue: any;
  newValue: any;
  changeType: any;

  constructor(
    fieldName: string,
    displayType: EditionMarketingFieldDisplayType,
    oldValue: string,
    newValue: string,
    changeType: string,
  ) {
    this.fieldName = fieldName;
    this.displayType = displayType;
    this.oldValue = oldValue;
    this.newValue = newValue;
    this.changeType = changeType;
  }
}

export class EditionMarketingDiffModel {
  appId: string;
  editionId: string;
  editionName: string;
  topLevelDataChanges: ChangedField[] = [];
  endUserMarketingChanges: ChangedField[] = [];
  resellerMarketingChanges: ChangedField[] = [];

  hasChanges(): boolean {
    return !!(
      this.topLevelDataChanges.length ||
      this.endUserMarketingChanges.length ||
      this.resellerMarketingChanges.length
    );
  }
}
